module.exports = __webpack_public_path__ + "img/76056.e31df966.svg";